import { useState } from 'react'
import { useOpportunitiesContext } from '../context/opportunities/OpportunitiesProvider'
import { useOpportunityContext } from '../context/opportunity/OpportunityProvider'
import { OPPORTUNITIES_ACTIONS } from '../context/opportunities/OPPORTUNITIES_ACTIONS'
import OpportunityService from '../services/OpportunityService'
import { OPPORTUNITY_ACTIONS } from '../context/opportunity/OPPORTUNITY_ACTIONS'
import { useSourceContext } from '../context/source/SourceProvider'
import { SOURCE_ACTIONS } from '../context/source/SOURCE_ACTIONS'
import { toastError } from '../../helper'

export default function useOpportunitiesActions() {
  const { opportunitiesDispatch } = useOpportunitiesContext()
  const { opportunityDispatch } = useOpportunityContext()
  const { sourceDispatch } = useSourceContext()
  const [inProgress, setInProgress] = useState(false)

  async function getCountries() {
    try {
      opportunitiesDispatch({
        type: OPPORTUNITIES_ACTIONS.SET_IS_LOADING,
        payload: {
          isLoading: true,
        },
      })
      const { data } = await OpportunityService.getCountries()

      opportunitiesDispatch({
        type: OPPORTUNITIES_ACTIONS.SET_OPPORTUNITIES,
        payload: {
          countries: data.countries,
        },
      })
    } catch (error) {
      throw error
    } finally {
      opportunitiesDispatch({
        type: OPPORTUNITIES_ACTIONS.SET_IS_LOADING,
        payload: {
          isLoading: false,
        },
      })
    }
  }

  async function getOpportunities(countryId) {
    try {
      const { data } = await OpportunityService.getOpportunities(countryId)

      return data.opportunities
    } catch (error) {}
  }

  async function createCountryOpportunity(countryId, payload) {
    try {
      setInProgress(true)
      const { data } = await OpportunityService.createCountryOpportunity(
        countryId,
        payload,
      )
      return data.message
    } catch (error) {
      if (!error.response && !error.request) {
        toastError('لم يتم الاتصال بالخادم. يرجى التحقق من الاتصال بالإنترنت.')
      } else if (error.response) {
        toastError(error.response.data.error)
      } else if (error.request) {
        toastError('لم يتم استلام استجابة من الخادم. حاول مرة أخرى لاحقًا.')
      } else {
        toastError('حدث خطأ غير متوقع. حاول مرة أخرى لاحقًا.')
      }
    } finally {
      setInProgress(false)
    }
  }

  async function getCountryOpportunitySource(countryId) {
    try {
      sourceDispatch({
        type: SOURCE_ACTIONS.SET_IS_LOADING,
        payload: {
          isLoading: true,
        },
      })
      const { data } =
        await OpportunityService.getCountryOpportunitySource(countryId)
      sourceDispatch({
        type: SOURCE_ACTIONS.SET_SOURCE,
        payload: {
          source: data.source,
        },
      })
      return data.source
    } catch (error) {
    } finally {
      sourceDispatch({
        type: SOURCE_ACTIONS.SET_IS_LOADING,
        payload: {
          isLoading: false,
        },
      })
    }
  }

  async function updateCountryOpportunitySource(countryId, payload) {
    try {
      setInProgress(true)
      const { data } = await OpportunityService.updateCountryOpportunitySource(
        countryId,
        payload,
      )
      await getCountryOpportunitySource(countryId)
      return data.message
    } catch (error) {
      throw error
    } finally {
      setInProgress(false)
    }
  }

  async function getOpportunity(countryId, opportunityId) {
    try {
      const { data } = await OpportunityService.getOpportunity(
        countryId,
        opportunityId,
      )
      console.log(data)

      return data.opportunity
    } catch (error) {
      console.log(error)
    }
  }

  async function updateCountryOpportunity(countryId, opportunityId, payload) {
    try {
      setInProgress(true)
      const { data } = await OpportunityService.updateCountryOpportunity(
        countryId,
        opportunityId,
        payload,
      )
      return data.message
    } catch (error) {
      throw error
    } finally {
      setInProgress(false)
    }
  }

  const deleteOpportunity = async (countryId, opportunityId) => {
    try {
      setInProgress(true)
      const { data } = await OpportunityService.deleteCountryOpportunity(
        countryId,
        opportunityId,
      )
      await getCountries()
      return data.message
    } catch (error) {
      throw error
    } finally {
      setInProgress(false)
    }
  }

  return {
    getCountries,
    getOpportunities,
    createCountryOpportunity,
    getCountryOpportunitySource,
    updateCountryOpportunitySource,
    getOpportunity,
    updateCountryOpportunity,
    deleteOpportunity,
    inProgress,
  }
}
